<label [ngClass]="{'bold': bold}">{{label}}</label>
<ng-content></ng-content>
<br/>
